import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export async function validateCustomerSession(token, signal) {
  const base=(process.env.REACT_APP_CYBEDEFENDER_AI_URL || '/api').replace(/\/$/,'');
  const response=await fetch(base+'/cybedefender/me',{headers:{Authorization:'Bearer '+token},cache:'no-store',signal});
  if(response.status===401 || response.status===422)return false;
  if(!response.ok)throw new Error('Unable to verify your session. Please retry.');
  const data=await response.json();
  return data.ok===true && typeof data.user?.guid==='string';
}

export default function CustomerSessionMonitor({isAuthenticated,onInvalidated}) {
  const {pathname}=useLocation();
  useEffect(()=>{
    if(!isAuthenticated)return;
    const controller=new AbortController();
    let pending=false;
    async function check() {
      if(pending || document.visibilityState==='hidden')return;
      const token=localStorage.getItem('token');
      if(!token){onInvalidated();return;}
      pending=true;
      try {
        const valid=await validateCustomerSession(token,controller.signal);
        if(!controller.signal.aborted && token===localStorage.getItem('token') && !valid)onInvalidated();
      } catch(error) {
        // A transient network/server failure must not erase a valid saved session.
      } finally {pending=false;}
    }
    function storage(event) {if(event.key==='token')check();}
    check();
    window.addEventListener('focus',check);
    window.addEventListener('storage',storage);
    const timer=window.setInterval(check,60000);
    return ()=>{controller.abort();window.clearInterval(timer);window.removeEventListener('focus',check);window.removeEventListener('storage',storage);};
  },[isAuthenticated,onInvalidated,pathname]);
  return null;
}
